import React, { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";
import { CustomModal } from "./CustomModal";

interface ModalContextProps {
  showModal: (options: ModalOptions) => void;
  hideModal: () => void;
}

interface ModalOptions {
  title?: string;
  description?: string;
  content?: ReactNode;
  footer?: ReactNode;
}

const ModalContext = createContext<ModalContextProps | undefined>(undefined);

export const useModal = () => {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error("useModal must be used within a ModalProvider");
  return ctx;
};

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<ModalOptions>({});

  const showModal = (opts: ModalOptions) => {
    setOptions(opts);
    setOpen(true);
  };

  const hideModal = () => setOpen(false);

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      <CustomModal
        open={open}
        title={options.title}
        description={options.description}
        onClose={hideModal}
        footer={options.footer}
      >
        {options.content}
      </CustomModal>
    </ModalContext.Provider>
  );
};
